import { AuthProvider, RouteProvider, ToastProvider } from "./providers";
import { FeatureFlagProvider } from "./providers/FeatureFlagProvider";
import { usePreventNoBarScrolling } from "@repo/ui/components/Base/hooks/usePreventNoBarScrolling";

export default function App() {
  usePreventNoBarScrolling("html, body");

  return (
    <FeatureFlagProvider>
      <ToastProvider>
        <AuthProvider>
          <RouteProvider />
        </AuthProvider>
      </ToastProvider>
    </FeatureFlagProvider>
  );
}
